let setItem = (key, value) => {
  try {
    let storage = sessionStorage.getItem('storage');

    if (!storage) {
      let new_storage_obj  = {};
      new_storage_obj[key] = value;
      let stringified      = JSON.stringify(new_storage_obj);
      sessionStorage.setItem('storage', stringified);
    }

    if (storage) {
      let storage_obj  = JSON.parse(storage);
      storage_obj[key] = value;
      let stringified  = JSON.stringify(storage_obj);
      sessionStorage.setItem('storage', stringified);
    }

  } catch (err) {
    console.log("Save Error:")
    console.log(err)
  }
}

let getItem = (key) => {
  try  {
    let storage     = sessionStorage.getItem('storage');
    let storage_obj = JSON.parse(storage);

    if (storage && storage_obj && storage_obj[key] !== null) {
      return storage_obj[key];
    }

    return null;
  } catch (err) {
    return null;
  }
}

export {
  setItem,
  getItem
}
